@if (product$ | async; as product) {
  <div class="container" style="margin-bottom: 25px;">
    <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
      <p [innerHTML]="product?.description" class="summary"></p>
    </ng-template>
    <!-- <ng-template [cxOutlet]="outlets.SUMMARY" [cxOutletContext]="{ product: product }">
    <p [innerHTML]="product?.summary" class="summary"></p>
  </ng-template> -->
  <!-- <div *ngIf="product?.refundable; else templateName">
  <span class="label">{{ 'pdp.productRefundlabel' | cxTranslate }}</span>
</div>
<ng-template #templateName>
  <span class="label"> {{ 'pdp.productNonRefundlabel' | cxTranslate }}</span>
</ng-template> -->
<ng-template [cxOutlet]="outlets.PRICE" [cxOutletContext]="{ product: product }">
  @if (product?.price) {
    <div [attr.aria-label]="'productSummary.newItemPrice' | cxTranslate" class="price mt-4">
      {{ 'pdp.price' | cxTranslate }} {{ product?.price?.formattedValue }}
    </div>
  }
</ng-template>
<!-- @TODO: Temp. Comment out share link while not in use by CMS -->
<!-- <ng-container *cxOutlet="outlets.SHARE">
<div>
  <a href="#" class="share btn-link">
    {{ 'productSummary.share' | cxTranslate }}
  </a>
</div>
</ng-container> -->
</div>
}
